import { render, staticRenderFns } from "./NodesSelect.vue?vue&type=template&id=4523dfc6&scoped=true&"
import script from "./NodesSelect.vue?vue&type=script&lang=js&"
export * from "./NodesSelect.vue?vue&type=script&lang=js&"
import style0 from "./NodesSelect.vue?vue&type=style&index=0&id=4523dfc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523dfc6",
  null
  
)

export default component.exports